import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

// Helper function to get auth headers with Bearer token
const getAuthHeaders = () => {
    const token = localStorage.getItem('accessToken');
    return {
        'accept': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
    };
};

/**
 * Fetch list of Join With Us submissions with pagination, search and status filter
 */
export const getJoinWithUs = async (page = 1, limit = 10, search = '', status = '') => {
    try {
        const params = new URLSearchParams({
            page: page.toString(),
            ...(limit !== undefined && limit !== 10 && { limit: limit.toString() }),
            ...(search && { search }),
            ...(status && { status })
        });

        const response = await axios.get(`${apiUrlOne}/join-with-us?${params}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching join with us list:", error);
        throw error;
    }
};

/**
 * Fetch a single Join With Us submission by ID
 */
export const getJoinWithUsById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/join-with-us/${id}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching join with us details:", error);
        throw error;
    }
};

/**
 * Update status & remarks of a Join With Us submission
 */
export const updateJoinWithUs = async (id, updateData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/join-with-us/${id}`, updateData, {
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating join with us record:", error);
        throw error;
    }
};

/**
 * Delete a Join With Us submission
 */
export const deleteJoinWithUs = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/join-with-us/${id}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting join with us record:", error);
        throw error;
    }
};
